import React from 'react'
import style from './height.module.css'

export default function OpeningHours(props) {
    return (
        <div className={`container ${style.hours} `}>
            <h4><u>Opening Hours</u></h4> 
            {props.everyday ?
                    <div className={`row ${style.time}`}>
                        <p className="col">MON-SUN:</p>
                        <p className="col righttext">24/7</p>
                    </div>
                : <>
                    <div className="row">
                        <p className="col">MON-SAT:</p>
                        <p className="col righttext">{props.open} - {props.close}</p>
                    </div>
                    <div className="row">
                        <p className="col">SUN:</p>
                        <p className="col righttext">{props.openSun} - {props.closeSun}</p>
                    </div>
                </>}
        </div>
    )
}
